module.exports = __webpack_public_path__ + "static/media/logo-safra.7b78af3b.png";